import React, { Component } from 'react';
import { Text } from '@components-library/Typography';
import { TableHeaderRangeFilter } from '@components-shared/table/PaginationTable';
import { keyMap } from '@locales/lokalise/keyMap';
import { InputRangeWithSlider } from 'components/shared/forms/InputRangeWithSlider';
import { TableHeaderFilterTypes } from '../types';
import styles from './styles.module.scss';

export type TableHeaderFilterProps<T> = {
  keyName: string;
  onFilter: (name: string, value: T) => void;
  filterType: TableHeaderFilterTypes;
  limitRange?: number[];
  initialState: T;
  headerFilterDefaultValue: T;
};

export type TableHeaderFilterState<T> = {
  filterTypeValue: T;
};

export class TableHeaderFilter<T> extends Component<TableHeaderFilterProps<T>, TableHeaderFilterState<T>> {
  state: TableHeaderFilterState<T> = {
    filterTypeValue: this.props.initialState,
  };

  onSubmitFilter = (event: React.FormEvent): void => {
    event.preventDefault();
    const { keyName, onFilter } = this.props;
    const { filterTypeValue } = this.state;

    onFilter(keyName, filterTypeValue);
  };

  onClearFilter = (): void => {
    const { keyName, onFilter, headerFilterDefaultValue } = this.props;

    onFilter(keyName, headerFilterDefaultValue);
  };

  onChange = (keyName: string, value: T): void => {
    this.setState({ filterTypeValue: value });
  };

  getComponentByFilterType = (type: TableHeaderFilterTypes): JSX.Element => {
    const { keyName, limitRange: limitRange } = this.props;

    switch (type) {
      case 'numberRangeWithSlider': {
        const limitFromValue = limitRange && limitRange[0];
        const limitToValue = limitRange && limitRange[1];
        const inputRangeWithSliderInitialState = this.state.filterTypeValue as unknown as TableHeaderRangeFilter;

        return (
          <InputRangeWithSlider<T>
            keyName={keyName}
            onChange={this.onChange}
            initialState={inputRangeWithSliderInitialState}
            limitToValue={limitToValue}
            limitFromValue={limitFromValue}
          />
        );
      }
    }
  };

  render() {
    return (
      <form onSubmit={this.onSubmitFilter}>
        <div>{this.getComponentByFilterType(this.props.filterType)}</div>
        <div className={styles.controlButtons}>
          <button type="button" className="btn btn--tiny light-white--button" onClick={this.onClearFilter}>
            <Text>{keyMap.sharedActionsClear}</Text>
          </button>
          <button type="submit" className="btn btn--tiny">
            <Text>{keyMap.sharedActionsFilter}</Text>
          </button>
        </div>
      </form>
    );
  }
}
